// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-task-modal {
  height: max-content;
  max-height: 100vh;
  display: flex;
  padding-bottom: 0 !important;
  flex-direction: column;
  width: max-content;
  max-width: 824px !important;
}
.manage-task-modal .modal-body {
  height: 100%;
  max-height: calc(100vh - 138px);
  display: flex;
  padding-bottom: 32px;
  flex-direction: column;
  padding-bottom: 0;
}
.manage-task-modal .modal-body .select-forms-title {
  font-size: 18px;
  margin-bottom: 16px;
  color: #2d3648;
  font-weight: 600;
}
.manage-task-modal .modal-body .task-name-group {
  margin-bottom: 34px;
}
.manage-task-modal .modal-body .forms--container {
  min-height: 300px;
  display: flex;
  gap: 32px;
  align-items: stretch;
}
.manage-task-modal .modal-body .forms--container .no--result {
  padding: 24px 27px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: #101828;
}
.manage-task-modal .modal-body .forms--container .forms--suggest {
  width: 100%;
  max-width: 426px;
  position: relative;
}
.manage-task-modal .modal-body .forms--container .forms--suggest .lds-ring-wrapper {
  position: absolute !important;
  width: unset !important;
  height: unset !important;
}
.manage-task-modal .modal-body .forms--container .forms--suggest .forms--suggest__list {
  height: 384px;
  max-height: 384px;
  overflow: hidden auto;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: #ffffff;
}
.manage-task-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox {
  min-height: 64px;
  width: 100%;
  margin-bottom: 0;
  padding: 14px 27px;
}
.manage-task-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox:nth-child(n+2) {
  border-top: 1px solid #dadee4;
}
.manage-task-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox .input {
  margin-top: -14px;
  margin-left: -27px;
}
.manage-task-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox .label {
  display: flex;
  align-items: center;
}
.manage-task-modal .modal-body .forms--container .selected--forms {
  width: 50%;
}
.manage-task-modal .modal-body .forms--container .selected--forms .selected--forms__title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: var(--Secondary-On-Surface, #98a2b3);
}
.manage-task-modal .modal-body .forms--container .selected--forms .selected--forms__list {
  display: block;
  margin-top: 16px;
  max-height: 384px;
  height: 100%;
  overflow: hidden auto;
}
.manage-task-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  margin-right: 5px;
  gap: 0;
}
.manage-task-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item p {
  width: fit-content;
}
.manage-task-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item:hover {
  color: #7f56d9;
}
.manage-task-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item svg {
  cursor: pointer;
  margin-left: 10px;
  flex-shrink: 0;
}
.manage-task-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item svg:hover {
  opacity: 0.7;
}
.manage-task-modal .modal-footer {
  width: calc(100% + 64px);
  position: initial;
  margin-top: 0px;
  justify-content: space-around;
}
.manage-task-modal .modal-footer .btn {
  padding: 10px 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/tasks/components/modals/manage-task-modal/styles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;AACF;AACE;EACE,YAAA;EACA,+BAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;AACJ;AACI;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACN;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,iBAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;AADN;AAEM;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAGM;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AADR;AAGQ;EACE,6BAAA;EACA,uBAAA;EACA,wBAAA;AADV;AAIQ;EACE,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAFV;AAIU;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAFZ;AAIY;EACE,6BAAA;AAFd;AAKY;EACE,iBAAA;EACA,kBAAA;AAHd;AAMY;EACE,aAAA;EACA,mBAAA;AAJd;AAUM;EACE,UAAA;AARR;AASQ;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;AAPV;AAUQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;AARV;AAUU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,MAAA;AARZ;AAUY;EACE,kBAAA;AARd;AAWY;EACE,cAAA;AATd;AAWY;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AATd;AAUc;EACE,YAAA;AARhB;AAiBE;EACE,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,6BAAA;AAfJ;AAiBI;EACE,kBAAA;AAfN","sourcesContent":[".manage-task-modal {\n  height: max-content;\n  max-height: 100vh;\n  display: flex;\n  padding-bottom: 0 !important;\n  flex-direction: column;\n  width: max-content;\n  max-width: 824px !important;\n\n  .modal-body {\n    height: 100%;\n    max-height: calc(100vh - 138px);\n    display: flex;\n    padding-bottom: 32px;\n    flex-direction: column;\n    padding-bottom: 0;\n\n    .select-forms-title {\n      font-size: 18px;\n      margin-bottom: 16px;\n      color: #2d3648;\n      font-weight: 600;\n    }\n\n    .task-name-group {\n      margin-bottom: 34px;\n    }\n\n    .forms--container {\n      min-height: 300px;\n      display: flex;\n      gap: 32px;\n      align-items: stretch;\n      .no--result {\n        padding: 24px 27px;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        color: #101828;\n      }\n\n      .forms--suggest {\n        width: 100%;\n        max-width: 426px;\n        position: relative;\n\n        .lds-ring-wrapper {\n          position: absolute !important;\n          width: unset !important;\n          height: unset !important;\n        }\n\n        .forms--suggest__list {\n          height: 384px;\n          max-height: 384px;\n          overflow: hidden auto;\n          border-top-left-radius: 6px;\n          border-top-right-radius: 6px;\n          background-color: #ffffff;\n\n          .form-control-checkbox {\n            min-height: 64px;\n            width: 100%;\n            margin-bottom: 0;\n            padding: 14px 27px;\n\n            &:nth-child(n + 2) {\n              border-top: 1px solid #dadee4;\n            }\n\n            .input {\n              margin-top: -14px;\n              margin-left: -27px;\n            }\n\n            .label {\n              display: flex;\n              align-items: center;\n            }\n          }\n        }\n      }\n\n      .selected--forms {\n        width: 50%;\n        .selected--forms__title {\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 400;\n          color: var(--Secondary-On-Surface, #98a2b3);\n        }\n\n        .selected--forms__list {\n          display: block;\n          margin-top: 16px;\n          max-height: 384px;\n          height: 100%;\n          overflow: hidden auto;\n\n          .selected--forms__list__item {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin: 10px 0;\n            margin-right: 5px;\n            gap: 0;\n\n            p {\n              width: fit-content;\n            }\n\n            &:hover {\n              color: #7f56d9;\n            }\n            svg {\n              cursor: pointer;\n              margin-left: 10px;\n              flex-shrink: 0;\n              &:hover {\n                opacity: 0.7;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .modal-footer {\n    width: calc(100% + 64px);\n    position: initial;\n    margin-top: 0px;\n    justify-content: space-around;\n\n    .btn {\n      padding: 10px 50px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
